import React from 'react';
import { BellIcon } from 'lucide-react';
interface NotificationBadgeProps {
  count: number;
  onClick?: () => void;
}
export function NotificationBadge({
  count,
  onClick
}: NotificationBadgeProps) {
  return <button onClick={onClick} className="relative p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label={`${count} notifications`} data-id="element-182">
      <BellIcon className="w-6 h-6 text-[#1f5070]" data-id="element-183" />
      {count > 0 && <span className="absolute top-0 right-0 bg-[#E53935] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-id="element-184">
          {count}
        </span>}
    </button>;
}